import { render, staticRenderFns } from "./createdOne.vue?vue&type=template&id=5604837b&scoped=true"
import script from "./createdOne.vue?vue&type=script&lang=js"
export * from "./createdOne.vue?vue&type=script&lang=js"
import style0 from "./createdOne.vue?vue&type=style&index=0&id=5604837b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604837b",
  null
  
)

export default component.exports